class WLSNCompareAids extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      compareData: 'js-wlsn-compare-aids-compare-data',
      dropdown: 'js-wlsn-compare-aids-dropdown',
      column: 'js-wlsn-compare-aids-col',
      cell: 'js-wlsn-compare-aids-cell',
      cellImageWrapper: 'js-wlsn-compare-aids-cell-image-wrapper',
      cellText: 'js-wlsn-compare-aids-cell-text',
      link: 'js-wlsn-compare-aids-link',
      description: 'js-wlsn-compare-aids-description',
      subtitle: 'js-wlsn-compare-aids-subtitle',
      price: 'js-wlsn-compare-aids-price',
      label: 'js-wlsn-compare-aids-label',
      headerImageWrapper: 'js-wlsn-compare-aids-header-image-wrapper'
    };

    this.selectors = {
      compareData: this.querySelectorAll(`.${this.classes.compareData}`),
      dropdowns: this.querySelectorAll(`.${this.classes.dropdown}`),
    };
  }

  connectedCallback() {
    this.initDropdowns();
    this.updateColumnsForMobile();
    window.addEventListener('resize', () => this.updateColumnsForMobile());
  }

  initDropdowns() {
    const dropdowns = this.selectors.dropdowns;

    dropdowns.forEach((dropdown) => {
      const columnEl = dropdown.closest(`.${this.classes.column}`);
      if (!columnEl) return;

      const currentLink = columnEl.querySelector(`.${this.classes.link}`);
      const currentHandle = currentLink?.dataset.productHandle || null;

      if (currentHandle) {
        const optionToSelect = Array.from(dropdown.options).find(
          (opt) => opt.value === currentHandle
        );
        if (optionToSelect) optionToSelect.selected = true;
      }

      dropdown.addEventListener('change', (event) => {
        const selectedHandle = event.target.value;
        this.updateColumn(columnEl, selectedHandle);
      });
    });
  }

  updateColumn(columnEl, productHandle) {
    const rawData = this.querySelector(
      `.${this.classes.compareData}[data-product-handle="${productHandle}"]`
    );
    if (!rawData) return;

    const data = JSON.parse(rawData.textContent);
    if (!data) return;

    if (data.image && data.image.trim() !== '') {
      const img = columnEl.querySelector('.js-wlsn-compare-aids-image');
      if (img) {
        img.src = data.image;
        img.srcset = data.image;
        img.alt = data.title || '';
      }
    }

    const labelEl = columnEl.querySelector(`.${this.classes.label}`);
    if (labelEl) {
      if (data.label && data.label.trim() !== '') {
        labelEl.textContent = data.label;
        labelEl.style.color = data.label_text_color || '';
        labelEl.style.backgroundColor = data.label_background_color || '';
        labelEl.style.display = '';
      } else {
        labelEl.style.display = 'none';
      }
    }

    const priceEl = columnEl.querySelector(`.${this.classes.price}`);
    if (priceEl) {
      priceEl.innerHTML = data.price && data.price.trim() !== '' ? data.price : '-';
    }

    const descEl = columnEl.querySelector(`.${this.classes.description}`);
    if (descEl) {
      descEl.textContent = data.description && data.description.trim() !== '' ? data.description : '-';
    }

    const subtitleEl = columnEl.querySelector(`.${this.classes.subtitle}`);
    if (subtitleEl) {
      subtitleEl.textContent = data.subtitle && data.subtitle.trim() !== '' ? data.subtitle : '';
    }

    const linkEl = columnEl.querySelector(`.${this.classes.link}`);
    if (linkEl) {
      if (data.url && data.url.trim() !== '') {
        linkEl.href = data.url;
        linkEl.dataset.productHandle = productHandle;
        linkEl.style.display = '';
      } else {
        linkEl.style.display = 'none';
      }
    }

    const cellContainer = columnEl.querySelectorAll(`.${this.classes.cell}`);
    const cellsData = Array.isArray(data.cells) ? data.cells : [];

    cellContainer.forEach((cellEl, i) => {
      const cellData = cellsData[i];

      const imgWrapper = cellEl.querySelector(`.${this.classes.cellImageWrapper}`);
      if (imgWrapper) {
        imgWrapper.innerHTML = '';
        if (cellData && cellData.image && cellData.image.trim() !== '') {
          const img = document.createElement('img');
          img.className = 'wlsn-compare-aids__table-column-cell-image js-wlsn-compare-aids-cell-image';
          img.src = cellData.image;
          img.alt = cellData.text || '';
          imgWrapper.appendChild(img);
        }
      }

      const text = cellEl.querySelector(`.${this.classes.cellText}`);
      if (text) {
        text.textContent = cellData && cellData.text && cellData.text.trim() !== '' 
          ? cellData.text 
          : '-';
      }
    });
  }

  updateColumnsForMobile() {
    const isMobile = window.innerWidth <= 1023;
    const columns = this.querySelectorAll(`.${this.classes.column}`);

    columns.forEach((col, i) => {
      if (isMobile) {
        col.style.display = i === 0 ? 'block' : 'none';
      } else {
        col.style.display = 'block';
      }
    });
  }
}

customElements.define('wlsn-compare-aids', WLSNCompareAids);

window.addEventListener('pageshow', () => {
  document.querySelectorAll('wlsn-compare-aids').forEach(component => {
    const columns = component.querySelectorAll('.js-wlsn-compare-aids-col');

    columns.forEach(col => {
      const link = col.querySelector('.js-wlsn-compare-aids-link');
      const dropdown = col.querySelector('.js-wlsn-compare-aids-dropdown');
      if (!link || !dropdown) return;

      const handle = link.dataset.productHandle;
      if (!handle) return;

      dropdown.value = handle;

      if (typeof component.updateColumn === 'function') {
        component.updateColumn(col, handle);
      }
    });
  });
});